// extracted by mini-css-extract-plugin
export default {"moviePosterImage":"index_moviePosterImage__2A023"};